import {Box, Grid, Skeleton, Typography} from '@mui/material';
import {ClockTime} from '@vectopus/atlas-icons-react';
import {useTranslation} from "react-i18next";
import React, {useContext, useMemo} from "react";
import {AppContext} from '@/utils/appContext';
import {useCountdownDate} from '@/hooks/use-countdown';
import {makeStyles} from "tss-react/mui";

const CartTimeAlert = () => {
  const {t} = useTranslation();
  const {classes} = useStyles();
  const appContext = useContext(AppContext);
  if (!appContext.cartExpireAt) return (<></>);
  const {distance, timer} = useCountdownDate(appContext.cartExpireAt)


  return (
    <Box p={3} pt={2} pb={2} mt={4} className={classes.root}>
      <Grid container direction={'row'} alignItems={'flex-start'} justifyContent={'center'}>
        <Grid item xs={10} md={6}>
          <Box sx={{display: 'flex'}}>
            <ClockTime size={24}/>
            <Typography variant={'h6'} component={'h6'} pl={1}>
              {t('Tempo residuo')}:
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={2} md={6} textAlign={'right'}>
          {
            distance > 0 ? (
              <Typography variant={'h6'} component={'h6'}>
                {timer}
              </Typography>
            ) : (
              <Box sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                <Skeleton variant="rectangular" width={20} height={20} /> : <Skeleton variant="rectangular" width={20} height={20} />
              </Box>
            )
          }
        </Grid>
        <Grid item xs={12} pt={1}>
          <Typography variant={'body2'} component={'p'}>
            {t('Possiamo_salvare_carrello')}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
export default CartTimeAlert;

const useStyles = makeStyles()((theme) => {
  return {
    root: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };
});
